import { render, staticRenderFns } from "./VerticalFormBlock.vue?vue&type=template&id=5344d09e&"
import script from "./VerticalFormBlock.vue?vue&type=script&lang=ts&"
export * from "./VerticalFormBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports